/**
 * Prepends an optimistic status_history entry to a vuln object.
 * Returns the same vuln reference unchanged if the entry is already recorded.
 *
 * @param {Object} vuln        - Current vuln object (or spread copy).
 * @param {string} newStatus   - The new status value being applied.
 * @param {string} user        - Username performing the change.
 * @param {Array}  [fallback]  - Fallback history when vuln.status_history is absent
 *                               (e.g. the pre-request vulnBefore.status_history).
 */
const applyOptimisticStatusHistory = (vuln, newStatus, user, fallback) => {
  const existingHistory = vuln.status_history ?? fallback ?? [];
  if (existingHistory.length > 0 && existingHistory[0].status === newStatus) { return vuln; }
  return {
    ...vuln,
    status_history: [
      { status: newStatus, change_date: new Date().toISOString(), user },
      ...existingHistory
    ]
  };
};

export default applyOptimisticStatusHistory;
